// extracted by mini-css-extract-plugin
export default {"icon":"HeaderLogo_icon_TEbrf"};